<template lang="html">
    <div class="container-fluid p-5">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        Setting
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row search-form">
                                    <div class="col-md-3 mt-1">
                                        <select v-model="settingRequest.type" class="form-control">
                                            <option value="">Select Type</option>
                                            <option value="price">Max Price</option>
                                            <option value="batch">Batch</option>
                                            <option value="student">Student</option>
                                        </select>
                                        <small class="text-danger">{{validationData.type}}</small>
                                    </div>
                                    <div class="col-md-3 mt-1">
                                        <button class="btn btn-primary mr-1 fbutton" @click="addSetting()"><i class="fas fa-save"></i> Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h4 class="mt-5">Create Setting</h4>
                        <div class="mt-4" v-show="type == 'price'">
                            <div class="row search-form">
                                <div class="col-md-3 mt-1">
                                    <select v-model="settingRequest.condition" class="form-control">
                                        <option value="">Select Type</option>
                                        <option value="equal">Price Equal</option>
                                        <option value="greater_than">Price Greater Than</option>
                                        <option value="less_than">Price Less Than</option>
                                        <option value="equal_greater_than">Price Equal or Greater Than</option>
                                        <option value="equal_less_than">Price Equal or Less Than</option>
                                    </select>
                                    <small class="text-danger">{{validationData.type}}</small>
                                </div>
                                <div class="col-md-3 mt-1">
                                    <input type="number" v-model="settingRequest.max_price" class="form-control" placeholder="Enter Max Price">
                                    <small class="text-danger">{{validationData.max_price}}</small>
                                </div>
                                <div class="col-md-3 mt-1">
                                    <button class="btn btn-success mr-1 fbutton" @click="addPrice()"><i class="fas fa-save"></i> Add Price</button>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mt-4" v-show="type != 'price'">
                            <table class="common-table" >
                                <thead>
                                    <tr>
                                        <th v-if="type === 'batch'">Batch Code</th>
                                        <th v-if="type === 'student'">Student Code</th>
                                        <th>Name</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(data, index) in dataList" :key="data.id">
                                        <td v-if="type === 'batch'">{{ data.batch_code }}</td>
                                        <td v-if="type === 'student'">{{ data.student_code }}</td>
                                        <td>{{ data.name }}</td>
                                        <td>
                                            <button class="btn btn-option text-primary" style="border: none;" v-if="data.is_setting == true" @click="editData(data)"><i style="font-size: xx-large" class="fas fa-toggle-on"></i></button>
                                            <button class="btn btn-option text-primary" style="border: none;" v-else @click="editData(data)"><i style="font-size: xx-large" class="fas fa-toggle-off"></i></button>
                                            <!-- <button v-b-modal.bv-modal-delete class="btn btn-option text-danger" @click="deleteData(data)"><i class="fas fa-trash-alt"></i></button> -->
                                        </td>
                                    </tr>
                                    <tr v-if="dataList.length === 0">
                                        <td :colspan="Object.keys(columns).length + 1" class="text-center">Empty List</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="table-pagination-minimal">
                                <div class="table-pagination-row">
                                    <div v-if="dataList.length > 0 " class="table-info-minimal left-align">
                                        Showing <span>{{metaData.from}}</span> to <span>{{metaData.to}}</span> of <span>{{metaData.total}}</span> entries
                                    </div>
                                    <nav class="pagination-minimal">
                                        <ul>
                                            <li :class="{ 'disabled': metaData.prev_page_url === null }">
                                                <button @click.prevent="next(metaData.current_page-1)" :disabled="metaData.prev_page_url === null">
                                                    <i class="fas fa-angle-left"></i>
                                                </button>
                                            </li>
                                            <li v-for="page in metaData.last_page" :key="page"
                                                :class="{ 'active':metaData.current_page === page }"
                                                v-if="Math.abs(page - metaData.current_page) < 3 || page == metaData.last_page || page == 1">
                                                <button @click.prevent="next(page)">{{ page }}</button>
                                            </li>
                                            <li :class="{ 'disabled': metaData.current_page === metaData.last_page }">
                                                <button @click.prevent="next(metaData.current_page+1)" :disabled="metaData.current_page === metaData.last_page">
                                                    <i class="fas fa-angle-right"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div> <!-- close card-body -->
                </div> <!-- close card -->
            </div> <!-- close col-md-12 -->
        </div> <!-- close row -->
    </div> <!-- close container-fluid -->
</template>

<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
    import env from '../../enviorments'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name: 'settingView',
        metaInfo: {
            title: "Setting",
            titleTemplate: "%s ← MIC",
        },
        components: {
            Loading
        },
        data() {
            return {
                env,
                isLoading: false,
                fullPage: true,
                alert: "",
                id: '',
                dataList: [],
                type: '',
                settingRequest: {
                    type: '',
                    max_price: '',
                    condition: ''
                },
                permissions: '',
                columns: {
                    batch_code: "Batch Code",
                    student_code: "Student Code",
                    name: "Name",
                },
                filter: {
                    page: 1,
                    per_page: 20,
                    sort_direction: "asc",
                    sort_by: "created_at",
                    limit: 10,
                    search: "",
                    email: "",
                    role: ""
                },
                metaData: {
                    last_page: null,
                    current_page: 1,
                    from: null,
                    to: null,
                    total: null,
                    prev_page_url: null
                },
                validationData: {
                    type: "",
                    max_price: ""
                }
            }
        },
        watch: {
        '$route' (to, from) {
            this.fetchData()
        }
    },
        computed: {},
        methods: {
            ...mapActions({
                getSettingListAction: 'getSettingListAction',
                getSettingDetailAction: 'getSettingDetailAction',
                getSettingListAction: 'getSettingListAction',
                settingToggleAction: 'settingToggleAction',
                updateSettingAction: 'updateSettingAction',
                updatePriceAction: 'updatePriceAction',
            }),
            async getSettingDetail(id){
                this.isLoading = true
                let option = {id: id}
                await this.getSettingDetailAction({option}).then(res => {
                    if (res.success == true) {
                        this.type = res.data.type
                        this.settingRequest.type = res.data.type
                        this.settingRequest.max_price = res.data.max_price
                        this.settingRequest.condition = res.data.condition
                        console.log(res.data)
                        this.isLoading = false;
                    }
                }).catch(err => this.isLoading = true)
            },
            sortBy(column) {
                this.filter.sortKey = column
                if (this.filter.sortKey == column) {
                    if (this.filter.orderBy == "asc") {
                        this.filter.orderBy = "desc"
                    } else if (this.filter.orderBy == "desc") {
                        this.filter.orderBy = "asc"
                    }
                } else {
                    this.filter.orderBy = "asc"
                }
                this.fetchData()
            },
            async search() {
                this.filter.page = 1
                this.fetchData()
                this.$refs['my-modal'].hide()
            },
            async fetchData() {
                this.isLoading = true
                // Update the page query parameter in the URL
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        page: this.filter.page
                    }
                });
                let option = this.filter
                await this.getSettingListAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.dataList = res.data.data
                        this.metaData.last_page = res.data.meta.lastPage
                        this.metaData.current_page = res.data.meta.currentPage
                        this.metaData.prev_page_url = res.data.meta.prevPageUrl
                        this.metaData.from = res.data.meta.from
                        this.metaData.to = res.data.meta.to
                        this.metaData.total = res.data.meta.total
                        this.$router.replace({ 
                            path: 'setting', 
                            query: { 
                                page: this.filter.page, 
                                per_page: this.filter.per_page, 
                                sort_direction: this.filter.sort_direction, 
                                sort_by: this.filter.sort_by,
                            } 
                        }).catch(()=>{})
                        this.isLoading = false;
                    }
                }).catch(err => this.isLoading = true)
            },
            next: function (page) {
                this.filter.page = page
                this.fetchData();
            },
            reset(){
                this.$router.replace({ 
                    path: 'account-list', 
                    query: {
                       page: 1, 
                       per_page: 20, 
                       sort_direction: 'desc', 
                       sort_by: 'created_at',
                       search: '',
                       email: '',
                       role: ''
                    } 
                }).catch(()=>{})
                this.$router.go()
            },
            async addSetting() {
				this.isLoading = true
				let validation = this.validationRule()
				if (validation == true) {
					this.isLoading = false
					return
				}
		
				const formData = new FormData();
				formData.append('type', this.settingRequest.type);

				await this.updateSettingAction(
					formData
				).then(res => {
					if(res.success === true) {
						this.fetchData()
                        this.getSettingDetail()
					} else {
						this.message = res.message
					}
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
            async editData(data) {
				this.isLoading = true
		
				const formData = new FormData();
				formData.append('id', data.id);

				await this.settingToggleAction(
					formData
				).then(res => {
					if(res.success === true) {
						this.fetchData()
                        this.getSettingDetail()
					} else {
						this.message = res.message
					}
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
            async addPrice() {
				this.isLoading = true
				let validation = this.validationRule()
				if (validation == true) {
					this.isLoading = false
					return
				}
		
				const formData = new FormData();
				formData.append('max_price', this.settingRequest.max_price);
                formData.append('condition', this.settingRequest.condition);

				await this.updatePriceAction(
					formData
				).then(res => {
					if(res.success === true) {
						this.fetchData()
                        this.getSettingDetail()
					} else {
						this.message = res.message
					}
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
            checkPermission: function (key) {
                if(key in this.permissions){
                    return true
                }else{
                    return false
                }
            },
            validationRule() {
				let isValidation = []
				if (this.settingRequest.type == "") {
					this.validationData.type = "The type field is required."
					isValidation.push(true)
				} else {
					this.validationData.type = ""
					isValidation.push(false)
				}
				if (this.settingRequest.max_price == "") {
					this.validationData.max_price = "The max price field is required."
					isValidation.push(true)
				} else {
					this.validationData.max_price = ""
					isValidation.push(false)
				}

				if (isValidation.includes(true)) {
					return true
				} else {
					return false
				}
			}

        },
        async mounted() {
            let user = JSON.parse(window.localStorage.getItem('user'))
            this.permissions = user.permissions
            this.filter.page = this.$route.query.page
            this.filter.per_page = this.$route.query.per_page
            this.filter.sort_by = this.$route.query.sort_by
            this.filter.sort_direction = this.$route.query.sort_direction
            this.fetchData()
            this.getSettingDetail()
        }
    }
</script>
<style scoped lang="scss">
/* Large commission modal custom width */
.commission-modal-lg .modal-dialog {
    max-width: 900px;
}
   .badge-16 {
    font-size: 16px;
   }
</style>